import React from "react";

// StatusPill — coloured badge for Arrivals / Departures / In-house rows.
// Extracted from ReceptionTab.jsx (Iteration 62 — modularisation).
export default function StatusPill({ status, IT }) {
  const map = {
    arrived: { c: "bg-sage text-white border-sage", it: "Arrivato", en: "Arrived" },
    registered: { c: "bg-primary/15 text-primary border-primary/30", it: "Registrato", en: "Registered" },
    pending: { c: "bg-amber-500/20 text-amber-700 border-amber-500/40", it: "In attesa", en: "Pending" },
    // Departure-view variants (used when subview === "departures")
    departed:  { c: "bg-sage text-white border-sage", it: "Partito", en: "Departed" },
    in_house:  { c: "bg-primary/15 text-primary border-primary/30", it: "In casa", en: "In house" },
  };
  const s = map[status] || map.pending;
  return (
    <span
      className={`text-[11px] px-2 py-1 rounded-full border whitespace-nowrap ${s.c}`}
      data-testid={`reception-status-${status}`}
    >
      {IT ? s.it : s.en}
    </span>
  );
}
